import { api } from './baseApi';
export var restaurantStatsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getRestaurantVenueStats: builder.query({
                query: function (restaurantId) {
                    return ({
                        url: "/restaurants/".concat(restaurantId, "/stats/summary"),
                        method: 'GET',
                    });
                },
                providesTags: function (_result, _error, restaurantId) {
                    return [
                        { type: 'RestaurantStats', id: restaurantId },
                    ];
                },
            }),
        });
    },
});
export var useGetRestaurantVenueStatsQuery = restaurantStatsApi.useGetRestaurantVenueStatsQuery;
